import type { Nullable } from "models-webgl2";
import { Webgl2dRenderer } from "../../../webgl2d-renderer";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";
import { MeasurementComponent } from "../measurements-component";

export class MeasurementTextComponent extends Webgl2Component {
  private get _selectedComponent(): Nullable<MeasurementComponent> {
    const component = this._renderer.selectedComponent;
    return component instanceof MeasurementComponent ? component : null;
  }

  constructor(private readonly _renderer: Webgl2dRenderer) {
    super();
  }

  public getRenderData() {
    const selected = this._selectedComponent;
    if (!selected) return;
    // NOTE: render even for empty text while editing, so selection line won't overlap the label box
    if (!selected.text && !selected.textComponent.isEditing) return;

    this.transform.copy(selected.textComponent.transform);
    this._renderer.render();

    const material = Webgl2.materials.default;
    material.setTexture("u_texture0", selected.textComponent.texture);
    return { material };
  }
}

export default MeasurementTextComponent;
